/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class OrderApi {
    static getInstance() {
        if (!this.instance) this.instance = new OrderApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取订单列表
    async getOrderHead (param, page_num, page_size){
        let url = `/api/order/head/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取订单列表详情
    async getOrderLine (param){
        let url = `/api/order/line/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 订单发货
    async orderDelivery (param,id){
        // let url = `/api/order/head/${id}`
        let url = `/api/order/stock/out/${id}/courier`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取物流公司下拉
    async getCourierType (param,id){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取仓库下拉
    async getWarehouse(){
        let url = `/api/order/warehouse`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取发货记录
    async getDeliverRecord(param,page_num,page_size){
        let url = `/api/order/stock/out/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取物流信息
    async getCurrierInfo(param){
        let url = `/api/order/stock/out/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 根据仓库查库存
    async getInventories(param){
        let url = `/api/product/inventories`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 根据仓库查库存2
    async getInventories2(param){
        let url = `/api/product/mes/single/inventory`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取国家下拉配置
    async getCountry(param){
        // let url = `/api/system/dictionary/country`
        let url = `/api/system/country/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 出库时获取物流ID
    async getCourierId(param){
        let url = `/api/courier/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取物流明细
    async getCourierDetail(id){
        let url = `/api/courier/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取退款记录
    async getRefundRecord(param){
        let url = `/api/order/refund/record/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 创建订单
    async createOrder(param){
        let url = `/api/order/head/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 创建服务订单
    async createServiceOrder(param){
        let url = `/api/order/head/service/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 添加订单行
    async addOrderLine(param){
        let url = `/api/order/line`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取客户列表
    // async getCustomerList (param){
    //     let url = `/api/customer/query`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }

    async getCustomerList (param){
        let url = `/api/customer/entity/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    async getCustomerAddressList (param){
        let url = `/api/customer/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取产品列表
    async getProductList (param){
        let url = `/api/product/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 同步订单到erp
    async syncToERP (id){
        let url = `/api/order/head/sync/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 删除订单
    async delOrder (id){
        let url = `/api/order/head/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 删除订单行
    async delOrderLine (id){
        let url = `/api/order/line/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 新增客户
    async addCustomer (param){
        let url = `/api/customer`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑订单行
    async editOrderLine (id,param){
        let url = `/api/order/line/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 编辑订单头-订单状态
    async editOrderStatus (id,param){
        let url = `/api/order/head/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

     // 编辑订单状态-取消订单
     async cancelOrder (id,param){
        let url = `/api/order/head/update/status/${id}`
        let result = await this.getData(url,param,'get')
        return result
    }

    //订单行版本查询
    async getOrderLineRecord (param,num,size){
        let url = `/api/order/line/record/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    //发送发票到邮箱
    async sendInvoiceToEmail (orderName){
        let url = `/api/order/module/email?order_number=${orderName}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    //获取发送发票的次数
    async getSendInvoiceCount (orderId){
        let url = `/api/invoice/${orderId}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    //发送确认书到邮箱
    async sendConfirmationToEmail (orderName){
        let url = `/api/order/module/email/order?order_number=${orderName}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 删除发票
    async deleteInvoice (order_number){
        let url = `/api/invoice/remove/${order_number}?order_number=${order_number}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取预开发票号
    async getPreInvoiceNo (order_id, type){
        let url = `/api/invoice/get/number/${order_id}?order_id=${order_id}&type=${type}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 检验是否可以下载发票
    async validDownloadInvoice (order_id){
        let url = `/api/order/head/${order_id}/check/invoice`
        let result = await this.getData(url,{},'GET')
        return result
    }

     // 检查发票是否存在
     async validIsExistInvoice (order_id,type){
        let url = `/api/invoice/exist/${order_id}?order_id=${order_id}&type=${type}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 订单so取消、订单行取消
    async cancelSO (param,id,allFlag){
        let url = `/api/order/so/record/so/cancel/${id}?all_flag=${allFlag}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取so取消记录
    async getCancelSORecord (param){
        let url = `/api/order/so/record/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取税率
    async getTax (){
        let url = `/api/system/dictionary/tax`
        let result = await this.getData(url,{},'GET')
        return result
    } 

    // 获取发货申请-计划出库数量
    async getSchedulingQuantity (param){
        let url = `/api/order/stock/out/quantity?inventory_codes=${param.inventory_codes}&warehouse=${param.warehouse}`
        let result = await this.getData(url,{},'GET')
        return result
    } 

    // 获取订单来源
    async getOrderSource (param){
        // let url = `/api/system/source`
        // let result = await this.getData(url,param,'GET')
        // return result

        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出订单
    async exportOrder (param){
        let url = `/api/order/head/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出订单车辆
    async exportEBike (param){
        let url = `/api/order/head/export/query/line`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出订单客户
    async exportCustomer (param){
        let url = `/api/order/head/export/query/line/customer`
        let result = await this.getData(url,param,'POST')
        return result
    }

    /***************************************************退换货订单*****************************************************************/ 

    // 获取退货、换货、补寄记录
    async getReturnExchangeList(param){
        let url = `/api/order/back/record/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取退换货记录
    async getReturnExchangeRecord(param){
        let url = `/api/order/back/record`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 创建退换货单
    async createReturnExchangeOrder(param,id,type){
        let url = `/api/order/back/record/${id}?type=${type}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 上传文件
    async upload(param){
        let url = `/api/order/module/upload`
        let result = await this.getData(url,param,'POST','application/octet-stream')
        return result
    }

    // 获取整车数量
    async getBikeCount(param){
        let url = `/api/order/head/count`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取用户信息
    async getCustomer(id){
        let url = `/api/customer/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取bom物料
    async getBom(param){
        // let url = `/api/product/boms`
        let url = `/api/product/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取有库存的bom物料
    async getExistBom(param,warehouse){
        let url = `/api/product/exist?warehouse=${warehouse}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取bom类别
    async getBomCategory(){
        // let url = `/api/product/bom/category` 
        let url = `/api/product/category`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 退款
    async refundSave(param){
        let url = `/api/order/refund/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 订单退款（按行退款）
    async saveOrderRefundByLine(param){
        let url = `/api/order/refund/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存备注
    async saveComment(id,param){
        let url = `/api/order/head/${id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 订单行生产数量设置
    async updateProduce(param){
        let url = `/api/order/line/update/produce`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取用户
    async getUser(){
        let url = `/api/user/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取退货，换货，补寄的物流信息
    async getReturnLogisticsInfo(param){
        let url = `/api/order/back/record/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取发货记录，用于退货时选择需退货产品
    async getStockOutList(param){
        let url = `/api/order/stock/out/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 验证订单风险
    async vaildOrderRiskLevel(riskLevel, id){
        let url = `/api/order/head/${id}/risk/validate?id=${id}&risk_validate=${riskLevel}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导出未发货订单
    async exportUnshipOrder(param){
        let url = `/api/order/head/export/query/unship/line`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取最新有效订单号
    async getLastOrderNumber(param){
        // let url = `/api/order/head/max/number`
        let url = `/api/order/head/max/number/all`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 创建预付款订单
    async createPrePaidOrder(param){
        let url = `/api/order/prepaid/head/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 校验发货日期区间
    async vaildShipDateRange(param,customer_id){
        let url = `/api/system/deliveryBlock/check/${customer_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取实物订单行
    async getPhysicalOrderLine (param){
        let url = `/api/order/stock/out/service`
        let result = await this.getData(url,param,'GET')
        return result
    }

     // 校验订单行历史投保数量
     async vaildOrderServiceBindCcount (param){
        let url = `/api/order/service/bind/count`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 根据保险订单，获取实物订单及实物订单行
    async getServiceBindQuery (param){
        let url = `/api/order/service/bind/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取对应国家运费
    async getFreight(param){
        let url = `/api/order/head/bike/freight`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 虚拟订单确认，创建C&C订单
    async createC2COrder(param){
        let url = `/api/order/head/c2c/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 根据pick_up id获取客户信息及新的ERP Code
    async getERPCodeAndCustomerByPickUpId(param){
        let url = `/api/dealer/pickup/point/query`
        let result = await this.getData(url,param,'POST')
        return result
    }


    // 订单行上根据sku、quantity显示预计发货时间
    async getPlanDateBySKUQTY(param){
        let url = `/api/inventory/lock/available/sku/quantity`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取锁定库存列表
    async getLockInventoryList(param){
        let url = `/api/inventory/lock/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 按订单释放库存
    async releaseInventory(order_id){
        let url = `/api/inventory/lock/delete/order/${order_id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 按订单锁定库存
    async lockInventory(order_id){
        let url = `/api/inventory/lock/create/order/${order_id}?order_id=${order_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 修改订单/取消SO-获取锁定订单状态
    async getOrderLockStatus(id){
        let url = `/api/order/head/get/lock/quantity/${id}?id=${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 发货申请-获取订单可发货信息
    async getOrderShipmentEnabled(order_id){
        let url = `/api/order/head/shipment/enabled?order_id=${order_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 编辑订单行 用户备注
    async editLineUserNote(param, id){
        let url = `/api/order/line/${id}/user/note`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取支付折扣下拉配置
    async getPayDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取现金折扣下拉配置
    async getCashDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取支付方式可选账期下拉配置
    async getPayDayConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取现金折扣率计算天数下拉配置
    async getCashDiscountPayDayConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取库存仓库下拉配置
    async getWarehouseConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取是否欧盟国际语言模板
    async getEUFlagLang (param){
        let url = `/api/system/country/query`
        let result = await this.getData(url,param,'POST')
        return result
    }
   

    /***************************************************数据看板*****************************************************/ 

    // 获取整车销量
    // async getSaleNum(){
    //     let url = `/api/order/head/bike/count`
    //     let result = await this.getData(url,{},'GET')
    //     return result
    // }


    // 获取工厂出货量
    // async getOutboundNum(param){
    //     let url = `/api/order/head/count`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }

     // 按sku查询整车销量
    //  async getBikeNumBySku(sku){
    //     let url = `/api/order/line/sku/count?sku=${sku}`
    //     let result = await this.getData(url,{},'GET')
    //     return result
    // }

}

export {
    OrderApi
}